var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.6665 2.66622L7.75412 1.71229C7.91652 1.68184 8.08316 1.68184 8.24555 1.71229L13.3332 2.66622V8.85489C13.3332 10.8111 12.3254 12.6294 10.6665 13.6662L8.35317 15.1121C8.13699 15.2472 7.86268 15.2472 7.6465 15.1121L5.33317 13.6662C3.67427 12.6294 2.6665 10.8111 2.6665 8.85489V2.66622Z",
    fill: "#506EFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.44987 9.83333C7.29015 9.83333 7.13042 9.76944 7.00265 9.64167L5.72487 8.36389C5.46931 8.10833 5.46931 7.725 5.72487 7.46944C5.98043 7.21389 6.3957 7.21389 6.61931 7.46944L7.44987 8.3L9.5582 6.19167C9.81376 5.93611 10.1971 5.93611 10.4526 6.19167C10.7082 6.44722 10.7082 6.83056 10.4526 7.08611L7.89709 9.64167C7.76931 9.76944 7.60959 9.83333 7.44987 9.83333Z",
    fill: "#506EFA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.e8d0a0d0db2034f70251c56fcba0d179.svg";
export { ForwardRef as ReactComponent };